import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Row, Col } from 'antd';

import { FormContext } from '../../../../hooks/useForm';

import FormWrapper from '../../../FormWrapper';

const FreeTransfer = ({ path, disabled = false }) => {
  const { t } = useTranslation();
  const form = useContext(FormContext);

  const { input } = form;

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={8} lg={6} xl={6}>
        <FormWrapper.Number
          label={t(
            'entity.offers.restrictions.restriction.FREE_TRANSFER.duration',
          )}
          props={{ ...input(`${path}.value1`), disabled }}
        />
      </Col>

      <Col xs={24} sm={24} md={8} lg={6} xl={6}>
        <FormWrapper.Number
          label={t(
            'entity.offers.restrictions.restriction.FREE_TRANSFER.count',
          )}
          props={{ ...input(`${path}.value2`), disabled }}
        />
      </Col>
    </Row>
  );
};

export default FreeTransfer;
